import {Injectable} from '@angular/core';
import {Store, StoreConfig} from '@datorama/akita';

export interface EligibilityState {
}

export function createInitialState(): EligibilityState {
  return {
  };
}

@Injectable({providedIn: 'root'})
@StoreConfig({
  name: 'eligibility',
})
export class EligibilityStore extends Store<EligibilityState> {

  constructor() {
    super(createInitialState());
  }
}
